import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Products.scss";
import { FaChevronRight } from "react-icons/fa";

class Products extends Component {
  render() {
    const { bgClassName } = this.props
    return (
      <div className={`products py-5 ${bgClassName}`}>
        <div className="container">
          <div className="d-flex justify-content-between">
            <h2 className="text-primary">Explore Products By Autodeals</h2>
          </div>
          <div className="products-card">
            <div className="row">
              <div className="col-lg-3 col-6 px-2 mb-3">
                <Link to={"/car-import/"} className="text-decoration-none text-dark">
                  <div className="ctm-1">
                    <div>
                      <img loading="lazy" src={require("../../../assets/Images/explore-icons/car-import-3.png")} />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                        <h4>Car Import</h4>
                      <div className="arrow-icon">
                        <FaChevronRight />
                      </div>
                      {/* <p>Calculate import duty and taxes of your vehicle.</p> */}
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-6 px-2 mb-3">
                <Link to={"/car-import/custom-duty-calculator"} className="text-decoration-none text-dark">
                  <div className="ctm-1">
                    <div>
                      <img loading="lazy" src={require("../../../assets/Images/explore-icons/cusotm-duty.png")} />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                        <h4>Custom Duty Calculator</h4>
                      <div className="arrow-icon">
                        <FaChevronRight />
                      </div>
                      {/* <p>Calculate import duty and taxes of your vehicle.</p> */}
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-6 px-2 mb-3">
                <Link to={"/car-financing/car-loan-calculator"} className="text-dark text-decoration-none">
                  <div className="ctm-1">
                    <div>
                      <img loading="lazy" src={require("../../../assets/Images/explore-icons/car-finance-calculator.png")} />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                      <div class="d-flex flex-column">
                        <h4>Car Finance Calculator</h4>
                      </div>
                      <div className="arrow-icon">
                        <FaChevronRight />
                      </div>
                      {/* <p>To compare loan prices between different cars.</p> */}
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-6 px-2 mb-3">
                <Link to={"/price-calculator"} className="text-dark text-decoration-none">
                  <div className="ctm-1">
                    <div>
                      <img loading="lazy" src={require("../../../assets/Images/explore-icons/used-car-calculate.png")} />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                        <h4>Used Car Price Calculator</h4>
                      <div className="arrow-icon">
                        <FaChevronRight />
                      </div>
                      {/* <p>Before buy/sell try our used price calculator.</p> */}
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-6 px-2 mb-3">
                <Link to={"/auction-sheet-verification"} className="text-dark text-decoration-none">
                  <div className="ctm-1">
                    <div>
                      <img loading="lazy" src={require("../../../assets/Images/explore-icons/aution-sheet-verification.png")} />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                        <h4>Auction Sheet Verification</h4>
                      <div className="arrow-icon">
                        <FaChevronRight />
                      </div>
                      {/* <p>Japenese Car Auction Sheet Verification through AutoDeals.</p> */}
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-6 px-2 mb-3">
                <Link to={"/car-insurance"} className="text-dark text-decoration-none">
                  <div className="ctm-1">
                    <div>
                      <img loading="lazy" src={require("../../../assets/Images/explore-icons/vehile-insurance.png")} />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                        <h4>Vehicle Insurance</h4>
                      <div className="arrow-icon">
                        <FaChevronRight />
                      </div>
                      {/* <p>Compare and buy best price policy through AutoDeals.</p> */}
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-6 px-2 mb-3">
                <Link to={"/car-tracker"} className="text-dark text-decoration-none">
                  <div className="ctm-1">
                    <div>
                      <img loading="lazy" src={require("../../../assets/Images/explore-icons/vehile-tracker.png")} />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                        <h4>Vehicle Tracker</h4>
                      <div className="arrow-icon">
                        <FaChevronRight />
                      </div>
                      {/* <p>Buy car GPS tracker online in Pakistan through AutoDeals.</p> */}
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-6 px-2 mb-3">
                <Link to={"/recent-car-reviews"} className="text-dark text-decoration-none">
                  <div className="ctm-1">
                    <div>
                      <img loading="lazy" src={require("../../../assets/Images/explore-icons/car-review.png")} />
                    </div>
                    <div className="d-flex justify-content-between my-2">
                        <h4>Car Review</h4>
                      <div className="arrow-icon">
                        <FaChevronRight />
                      </div>
                      {/* <p>Buy car GPS tracker online in Pakistan through AutoDeals.</p> */}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Products;
